export enum EffectStatuteKind {
  /// <summary>
  /// ماهانه
  /// </summary>
  Monthly = 1,
  /// <summary>
  /// روزانه
  /// </summary>
  Daily = 2,
  /// <summary>
  /// ساعتی
  /// </summary>
  Hourly = 3,
}
